
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {EmpresaService} from "@/services/EmpresaService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {empresaStore} from "@/store/empresaStore";
import {IngresoService} from "@/services/IngresoService";
import {ingresoStore} from "@/store/ingresoStore";
import * as stream from "stream";
import router from "@/router";

@Component({
  name: "empresaNew",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private empresaStore = empresaStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private empresaService = EmpresaService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  empresa = {
    nombre: '',
    nit: '',
    direccion: '',
    ciudad: '',
    telefono: '',
    tipo_material_empresa_id: ''
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted() {
    this.getTipoMaterial();
  }

  get tipoMaterial(): any {
    return this.empresaStore.tipoMaterial;
  }

  getTipoMaterial() {
    this.empresaService.getTipoMaterial();
  }

  get loading(): boolean {
    return this.empresaStore.loading;
  }



  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar la nueva Empresa: <br>
                    ${this.empresa.nombre}`
    ).then(res => {
      const data = {empresa:this.empresa}
      if (res.isConfirmed) {
        this.empresaService.saveEmpresa(data);
        router.push({name: 'empresas'});
        //this.$emit('listar')
      }
    })
  }



}
